import { render, staticRenderFns } from "./RatePlate.vue?vue&type=template&id=805d67b0"
import script from "./RatePlate.vue?vue&type=script&lang=js"
export * from "./RatePlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports